import React, {useEffect} from 'react';

const useMouseWheelScroll = (
  containerRef: React.RefObject<HTMLDivElement>,
  options: { enabled: boolean } = { enabled: true }
) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container || !options.enabled) return;

    let modifier: number;
    
    const handleWheel = (event: any) => {
      if (event.deltaMode == event.DOM_DELTA_PIXEL) {
        modifier = 1;
        // иные режимы возможны в Firefox
      } else if (event.deltaMode == event.DOM_DELTA_LINE) {
        modifier = parseInt(getComputedStyle(container).lineHeight);
      } else if (event.deltaMode == event.DOM_DELTA_PAGE) {
        modifier = container.clientHeight;
      }
      if (event.deltaY != 0) {
        // замена вертикальной прокрутки горизонтальной
        container.scrollLeft += modifier * event.deltaY;
        event.preventDefault();
      }
    };

    container && container.addEventListener('wheel', handleWheel);

    return () => container && container.removeEventListener('wheel', handleWheel);
  }, [containerRef, options.enabled]);
};

export default useMouseWheelScroll;
